import React, {useRef} from 'react';

import CardsHeader from 'layouts/Headers/CardsHeader.js';

import {Alert, Col, Container,} from "reactstrap";

export default function Supplier() {

  return (
    <>
      <CardsHeader name="Admin" parentName="Suppliers" />

      <Container className="mt-2 admin-main-body" fluid >
        <Col md={4}>
          <Alert color="info">
            <strong>Info!</strong> This page was deprecated!
          </Alert>
        </Col>
      </Container>
    </>
  )
}